import { Button } from 'components/buttons/Button/Button';
import { countriesArray, languagesArray } from './mockData';
import { Dropdown } from 'components/Dropdown/Dropdown';
import HeaderButton from '../HeaderButton';

const CountrySelectorMenu = ({ onClose }) => {
    return (
        <div className="country-selector-popup">
            <div className="country-selector-popup__title">Change country</div>
            <HeaderButton onClick={onClose} size="small" />
            <form>
                <Dropdown label="PLEASE CHOOSE A COUNTRY" options={countriesArray} />
                <Dropdown label="AVAILABLE LANGUAGES" options={languagesArray} />
                <Button type="default">SAVE YOUR CHOICE</Button>
            </form>
        </div>
    );
};

export default CountrySelectorMenu;
